import { TableCell } from '@nike/eds'
import { type Column, type RowData } from '@tanstack/react-table'

import { ColumnType } from './Filter'
import './TableSkeleton.css'

interface SkeletonRowsProps {
  tableColumns: Array<Column<RowData, unknown>>
  columnTypeMapping: Map<string, { type: ColumnType, enumValues?: string[] }>
}

const getSkeletonClassForType = (type: ColumnType | undefined): string => {
  switch (type) {
    case ColumnType.NUMBER:
      return 'skeleton-number'
    case ColumnType.DATE:
      return 'skeleton-date'
    case ColumnType.BOOLEAN:
      return 'skeleton-boolean'
    default:
      return 'skeleton-text'
  }
}

export const TableSkeleton = ({ tableColumns, columnTypeMapping }: SkeletonRowsProps) => {
  const numRows = 15
  return (
    <>
      {Array.from({ length: numRows }).map((_, index) => (
        <tr key={`skeleton-${index}`} className="skeleton-row">
            {tableColumns.map(column => {
              const type = columnTypeMapping.get(column.id)?.type
              const skeletonClass = getSkeletonClassForType(type)

              return (
                    <TableCell
                        key={`skeleton-cell-${column.id}`}
                        style={{
                          minWidth: column.getSize(),
                          maxWidth: column.getSize()
                        }}
                    >
                        <div className={`skeleton-cell ${skeletonClass}`} />
                    </TableCell>
              )
            })}
        </tr>
      ))}
    </>
  )
}
